<template>
  <div class="new">

    <div class="newPhone">
      <div class="newPhoneNav">
        <img src="../assets/Palm Cube-Logo-09.png" alt="">
      </div>
      <div class="newImage">
        <img src="../assets/newImage.jpg" alt="">

      </div>
      <div class="demo1">
        <button class="demo" @click="getThere">
          Request a demo

        </button>
      </div>
      <!-- <div class="demo2">
        <button class="demo" @click="demo">Request a demo</button>
      </div>
      <div class="demo3">
        <button class="demo" @click="demo">Request a demo</button>
      </div>
      <div class="demo4">
        <button class="demo" @click="demo">Request a demo</button>
      </div> -->


    </div>
    <div class="aboutPhoneUs">

      <div>
        <img src="../assets/Palm Cube-Logo-06.png" alt="">
        <p class="Contact1">Contact US </p>
        <p>+234 9064837926 <br>lockettqin@palm-cube.com</p>
        <p class="Contact2">SHANGHAI </p>
        <p>Lumous intelligent Technology (shanghai)Co,Ltd</p>
        <p class="Contact2">LAGOS </p>
        <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
      </div>
      <div class="aboutPhoneUsright">
        <div>
          <input v-model="fullName" type="text" class="input" style="width: 300px; height: 30px;" placeholder="Name(*)">
        </div>
        <div>
          <input v-model="mobile" type="text" class="input" style="width: 300px; height: 30px;" placeholder="Mobile(*)">
        </div>
        <div>
          <input v-model="email" type="text" class="input" style="width: 300px; height: 30px; " placeholder="Email(*)">
        </div>
        <div>
          <textarea type="text" v-model="message" class="input" style="width: 300px; height: 80px; "
            placeholder="Leave your message..." />
        </div>
        <div>
          <button class="sand" @click="addClick" style="width: 80px;height: 30px;">Send</button>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      input: '',
      textarea: '',
      fullName: '',
      mobile: '',
      email: '',
      message: '',


    }
  },
  methods: {
    getThere() {
      window.scrollTo({
        top: 6900,
        behavior: "smooth"
      });
      // this.$router.push('/about');
    },
    addClick() {
      // axios.post('http://192.168.31.101:31200/customer/contact/add',{}).then(res => {
      axios.post('http://unicorn-uiserver-server.palm-cube.com/customer/contact/add ', {
        fullName: this.fullName, mobile: this.mobile, email: this.email, message: this.message
      }).then(res => {
        this.fullName = '',
          this.mobile = '',
          this.email = '',
          this.message = ''
        if (res.data.errCode == 0) {
          this.$router.push('/thanks');

          //   this.$notify({
          //   title: 'success',
          //   type: 'success'
          // });

        }
        // this.$message.success('添加成功！')
        console.log(res)
      }).catch(error => {
        console.log(error)
      })
    }
  },
}

</script>

<style lang="scss">
.new {
  //  height: 4000px;
  display: none;
}

.newPhone {
  position: relative;


  // height: 7000px;
  // width: 100%;
  // background: url(../assets/newImage.jpg) no-repeat;
  // background-size: 100%;
  .newPhoneNav {
    margin: 40px;
    // width: 100%;
    // height: 100px;

    img {
      text-align: left;
      display: block;
      margin-top: 100px;
      width: 200px,

    }
  }

  .newImage {
    width: 100%;
    height: auto;

    img {
      width: 100%;
    }
  }

  .demo1 {
    top: 400px;
    left: 60px;
    position: absolute;

    .demo {
      font-size: 20px;
      margin-top: 10px;
      width: 200px;
      height: 50px;
      background-color: #32c89b;
      text-align: center;
      color: #fff;
      border-radius: 30px;
      border: none;
    }

  }

  // .demo2{
  //   top: 2310px;
  //   left: 140px;
  //   position: absolute;
  //   .demo {
  //     font-size: 15px;
  //     margin-top: 10px;
  //     width: 150px;
  //     height: 35px;
  //     background-color: #32c89b;
  //     text-align: center;
  //     color: #fff;
  //     border-radius: 30px;
  //     border: none;
  //   }
  // }
  // .demo3{
  //   top: 3290px;
  //   left: 40%;
  //   position: absolute;
  //   .demo {
  //     font-size: 15px;
  //     margin-top: 10px;
  //     width: 150px;
  //     height: 35px;
  //     background-color: #32c89b;
  //     text-align: center;
  //     color: #fff;
  //     border-radius: 30px;
  //     border: none;
  //   }
  // }
  // .demo4{
  //   bottom: 600px;
  //   left: 40%;
  //   position: absolute;
  //   .demo {
  //     font-size: 15px;
  //     margin-top: 10px;
  //     width: 150px;
  //     height: 35px;
  //     background-color: #32c89b;
  //     text-align: center;
  //     color: #fff;
  //     border-radius: 30px;
  //     border: none;
  //   }
  // }

}

@media(max-width: 1200px) {
  .new {
    display: block;
  }

  .AppPh {
    display: block;

  }

  // .AppPhone{
  //   display: none;
  // }
}
</style>